import React from "react"

const { Dialog, DialogCardHead, DialogCardHeadIcon, Icon, DialogCardBody, Typography, DialogCardFooter, ButtonGroup, ButtonText } = require("@visa/vds")

const ApprovedProductsAllDialog = (props) => {
  return (
    <Dialog
      aria-labelledby="export-dialog"
      aria-describedby="export-dialog"
      onExit={() => props.setOpenDialog(false)}
      open={props.openDialog}
      type="warning"
      aria-label="custom warning"
      className="dialog-card"
    >
      <DialogCardHead>
        <DialogCardHeadIcon>
          <Icon name="warning" resolution="low" />
        </DialogCardHeadIcon>
      </DialogCardHead>
      <DialogCardBody className="dialog-card" id="dialog-description-example-3">
        <Typography>
          The Approved Products Data you are about to export includes Internal Only information and cannot be shared outside of Visa.
          If you wish to export data that can be shared externally, use the Export feature on the public-facing Approved Products page.
        </Typography>
      </DialogCardBody>
      <DialogCardFooter>
        <ButtonGroup direction="right">
          <ButtonText
            colorScheme="primary"
            onClick={() => {
              props.handleClickExport()
              props.setOpenDialog(false)
            }}>
            Ok
          </ButtonText>
          <ButtonText
            colorScheme="secondary"
            onClick={() =>props.setOpenDialog(false)}>
            Cancel
          </ButtonText>
        </ButtonGroup>
      </DialogCardFooter>
    </Dialog>
  )
}

export default ApprovedProductsAllDialog